import { CarryOutOutlined, FormOutlined, PlusOutlined, EditOutlined , QuestionCircleOutlined , DeleteOutlined } from '@ant-design/icons';
import { Switch, Tree, Button, Drawer, Space, Table, Tag, Row, Col, Tooltip, Popconfirm, Input } from 'antd';
import Title from 'antd/lib/skeleton/Title';
import Column from 'antd/lib/table/Column';
import React, { useState, useCallback } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import accountService from '../../../api/account.service';
import { DEFAULT_MASTER_DRAWER_WIDTH, SUCCESS_STATUS } from '../../../utility/Constants';
import commonUtility from '../../../utility/Utils';
import DrawableCloseIcon from '../../common/DrawableCloseIcon';
import PageLoader from '../../common/PageLoader';
import AccountGroupEntry from './AccountGroupEntry';
import CustomTableSearch from '../../common/CustomTableSearch';








const AccountGroupList = () => {
  const [searchText, setSearchText] = useState('');
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [filteredSearchList, setFilteredSearchList] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const state = useSelector((state) => state.accountgroup)

  const [isSuccessRefreshList, setIsSuccessRefreshList] = useState(false);

  const [accountGroupList, setAccountGroupList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isRender, setIsRender] = useState(false);


  const [accountGroupAddData, setAcountGroupAddData] = useState({
    group_id: 0,
    group_description: '',
    main_category: '',
    sub_category: '',
    group_alias: '',
    is_bank: '',
    group_parent_id: null,
    top_parent_id: 0,
    is_parent: 'Y',
    is_active: "Y",
    mode: "ADD"
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };




  const onSelect = (selectedKeys, info) => {
    console.log('selected', selectedKeys, info);
  };



  const handlePageLoading = () => {
    setIsPageLoading(false);
  }



  const confirmDelete = (e) => {
    console.log("Test Delete",e)

    
    const data = { formdata: { group_id: e} };
    accountService.deleteGroup(data).then((res) => {

      setIsSuccessRefreshList(false)
      if(res.response_data.affectedRows) {
        setIsSuccessRefreshList(true)
        // message.success(res.response_msg);
        commonUtility.openNotification("bottom", "Message", res.response_msg);
      }
      else{
        //message.error(res.response_msg);
        commonUtility.openNotification("bottom", "Message", res.response_msg);
      }
      
    });


  


  };
  
  const cancel = (e) => {
    console.log("No clik",e);
    //message.error('Click on No');
  };



  const openGroupActionSetting = (id, cliked_from) => {
    console.log(id, cliked_from)


    const data = { formdata: { group_id: id } };
    accountService.accountGroupDetailById(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const res_data = res.data.response_data[0];
        cliked_from == "EDIT" ?
          setAcountGroupAddData({
            group_id: res_data.group_id,
            group_description: res_data.group_description,
            main_category: res_data.main_category,
            sub_category: res_data.sub_category,
            group_alias: res_data.group_alias,
            is_bank: res_data.is_bank,
            group_parent_id: res_data.group_parent_id,
            top_parent_id: res_data.top_parent_id,
            is_parent: res_data.group_parent_id > 0 ? 'N' : 'Y',
            is_active: res_data.is_active,
            mode: "EDIT"
          })
          :

          // child
          setAcountGroupAddData({
            group_id: 0,
            group_description: '',
            main_category: '',
            sub_category: '',
            group_alias: '',
            is_bank: 'N',
            group_parent_id: res_data.group_id,
            top_parent_id: 0,
            is_parent: 'N',
            is_active: 'Y',
            mode: "ADD"
          });

        setVisible(true);
      }

    });

  }
  /*
  useEffect(() => {
    accountService.accountGroupList().then((res) => {
      console.log(res.data);
      if (res.data.response_status === SUCCESS_STATUS) {

        setAccountGroupList(res.data.response_data);
      }

    });
  }, []);
  */




  /*
    useEffect(() => {
      setAccountGroupList([]);
      const getAccountGroupList = async () => {
  
        accountService.accountGroupList().then((res) => {
  
          let groupListData = res.data.response_data;
  
  
          if (groupListData.length > 0) {
            setIsPageLoading(true);
            setIsLoading(true);
            const hashTable = Object.create({});
            let item = {};
  
            groupListData.forEach(aData => {
  
              item = {
                title: (<>
  
  
                  <Row style={{ width: "1000px !important" }}>
                    <Col xs={24} xl={12} className="tree-group-description">
                      <span >   {aData.group_description}  </span>
                    </Col>
                    <Col xs={24} xl={4}>
                      <span>   <Tag >{aData.main_category}</Tag>  <Tag color="orange">{aData.sub_category}</Tag> </span>
                    </Col>
                    <Col xs={24} xl={8}>
                      <Button type="default" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'ADD')}> Add group</Button>
                      <Button type="link" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'EDIT')}><EditOutlined /></Button>
                    </Col>
  
                  </Row>
  
                  
  
                </>),
                key: aData.group_id,
                id: aData.group_id,
                parent_id: aData.group_parent_id,
                icon: <EditOutlined />,
  
  
  
              }
              hashTable[item.id] = { ...item, children: [] }
            }
            );
  
  
  
  
            const dataTree = [];
            groupListData.forEach(aData => {
              item = {
                title: (<>
  
                  <Row style={{ width: "1000px !important" }}>
                    <Col xs={24} xl={12} className="tree-group-description">
                      <span >   {aData.group_description}  </span>
                    </Col>
                    <Col xs={24} xl={8}>
                      <Tag >{aData.main_category}</Tag>  <Tag color="orange">{aData.sub_category}</Tag>
                    </Col>
                    <Col xs={24} xl={8}>
                      <Button type="default" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'ADD')}> Add group</Button>
                      <Button type="link" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'EDIT')}><EditOutlined /></Button>
                    </Col>
  
                  </Row>
  
  
                  
  
  
                </>),
                key: aData.group_id,
                id: aData.group_id,
                parent_id: aData.group_parent_id,
                icon: <EditOutlined />,
  
  
              }
  
              if (item.parent_id > 0) {
                hashTable[item.parent_id].children.push(hashTable[item.id])
              }
              else {
  
                dataTree.push(hashTable[item.id])
              }
            });
  
  
  
            setAccountGroupList(dataTree);
           
          }
          else {
            // else length
            setIsPageLoading(false);
            setIsLoading(false);
          }
  
  
  
  
  
        }).then((res)=>{
          setIsPageLoading(false);
          setIsLoading(false);
        })
      }
      getAccountGroupList();
  
    }, [state.accountgroup]);
  */






  /**
   * 
   * Account List data
   * 
   */

  // const accountListDatas = useCallback(() => {
  //   setIsRender(false)
  //   accountService.accountGroupTreeList().then((res) => {

  //     console.log("Account Service")
  //     console.log(res.data.response_data)
  //     console.log("/Account Service")

  //     setAccountGroupList(res.data.response_data)
  //     setIsRender(true)

  //   });
  // }


  /*
  const accountListDatas = useCallback(() => {
    setIsRender(false)
    accountService.accountGroupList().then((res) => {

      console.log("Account Service")
      console.log(res.data.response_data)
      console.log("/Account Service")


      let groupListData = res.data.response_data;


      if (groupListData.length > 0) {
      
        const hashTable = Object.create({});
        let item = {};
        const dataTree = [];
        groupListData.forEach(aData => {

          item = {
            title: (<>


              <Row style={{ width: "1000px !important" , position : 'relative'}}>
              <Col xs={24} xl={12} className="tree-group-description tree-group">
                  <div > {aData.group_description}  </div>
                </Col>

                <Col xs={24} xl={4} style={{margin: "0px -10px"}} className="tree-group">
                  <span>   <Tag >{aData.main_category}</Tag>  <Tag color="orange">{aData.sub_category}</Tag> </span>
                </Col>
                <Col xs={24} xl={8} className="tree-group">
                  <Button type="default" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'ADD')}> Add group</Button>
                  <Button type="link" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'EDIT')}><EditOutlined /></Button>
                </Col>

               
              </Row>

              

            </>),
            key: aData.group_id,
            id: aData.group_id,
            parent_id: aData.group_parent_id,
            icon: <EditOutlined />,



          }
          hashTable[item.id] = { ...item, children: [] }
        }
        );




       
        groupListData.forEach(aData => {
          item = {
            title: (<>

              <Row style={{ width: "1000px !important" }}>
                <Col xs={24} xl={12} className="tree-group-description">
                  <span >   {aData.group_description}  </span>
                </Col>
                <Col xs={24} xl={8}>
                  <Tag >{aData.main_category}</Tag>  <Tag color="orange">{aData.sub_category}</Tag>
                </Col>
                <Col xs={24} xl={8}>
                  <Button type="default" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'ADD')}> Add group</Button>
                  <Button type="link" shape="round" size="small" onClick={() => openGroupActionSetting(aData.group_id, 'EDIT')}><EditOutlined /></Button>
                </Col>

              </Row>


              


            </>),
            key: aData.group_id,
            id: aData.group_id,
            parent_id: aData.group_parent_id,
            icon: <EditOutlined />,


          }

          if (item.parent_id > 0) {
            hashTable[item.parent_id].children.push(hashTable[item.id])
          }
          else {

            dataTree.push(hashTable[item.id])
          }
        });



        setAccountGroupList(dataTree);

        console.log("account group list",dataTree)
       
      }
      else {
       console("No Account group found")
      }




     // setAccountGroupList(res.data.response_data)
      setIsRender(true)
      
    });
  }, [accountGroupList]);


*/



  const groupColumn = [
    {
      title: 'Group Name',
      dataIndex: 'title',
      key: 'title',
      width: '60%',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      width: '10%',

      render: (selectedObj, record) => (

        <Space size="middle">


          {
            // console.log("slectedObj", record)
          }

          <Row>
            <Col xs={24} xl={4} style={{ margin: "0px -10px" }} className="tree-group">
              <div style={{ display: "flex" }}>   <Tag color="#f50" >{record.category}</Tag>  <Tag color="#108ee9">{record.subcategory}</Tag> </div>
            </Col>
          </Row>
        </Space>
      ),
    },

    {
      title: 'Action',
      key: 'action',
      render: (selectedObj, record) => (

        <Space size="middle">
          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}

          <Button style={{ backgroundColor: '#1a8811', color: '#FFF', fontWeight: '700', border: 0, fontSize:'13px' }} size="small" icon={<PlusOutlined />} onClick={() => openGroupActionSetting(record.id, 'ADD')}>
            Add Group
          </Button>
          {/* <Button type="link" shape="round" size="small" onClick={() => openGroupActionSetting(record.id, 'EDIT')}><EditOutlined /></Button> */}
          <Tooltip title="Edit">
            <Button size="small" style={{ backgroundColor: '#108ee9', color: '#FFF', fontWeight: '700', border: 0 , fontSize:'13px' }} type="dashed" icon={<EditOutlined />} onClick={() => openGroupActionSetting(record.id, 'EDIT')} >Edit</Button>
          </Tooltip>

          <>
              <Popconfirm
                title="Data cann't be undone if deleted. Do you want to delete? "
                icon={
                  <QuestionCircleOutlined
                    style={{
                      color: 'red',
                    }}
                  />
                }
                onConfirm={()=>confirmDelete(record.id)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button" type="danger" size="small" style={{ fontSize:'13px' }} >Delete <DeleteOutlined /></Button>
              </Popconfirm>
            </>


        </Space>
      ),
    },
  ];


  // Table View Code

  const accountListDatas = () => {
    setIsRender(false)
    accountService.accountGroupList().then((res) => {




      let groupListData = res.data.response_data;


      if (groupListData.length > 0) {

        const hashTable = Object.create({});
        let item = {};
        const dataTree = [];
        groupListData.forEach(aData => {

          item = {
            title: aData.group_description,
            category: aData.main_category,
            subcategory: aData.sub_category,
            key: aData.group_id,
            id: aData.group_id,
            parent_id: commonUtility.sanitizeValue(aData.group_parent_id) > 0 ? aData.group_parent_id : 0
          }
          hashTable[item.id] = { ...item, children: [] }
        }
        );





        groupListData.forEach(aData => {
          item = {
            title: aData.group_description,
            category: aData.main_category,
            subcategory: aData.sub_category,
            key: aData.group_id,
            id: aData.group_id,
            parent_id: commonUtility.sanitizeValue(aData.group_parent_id) > 0 ? aData.group_parent_id : 0
          }

          if (item.parent_id > 0) {
            hashTable[item.parent_id].children.push(hashTable[item.id])
          }
          else {

            dataTree.push(hashTable[item.id])
          }
        });

        const x = commonUtility.removeEmptyElements(dataTree)

        setAccountGroupList(x);
        setFilteredSearchList(x);

        // console.log("account group list QWER", x)

      }
      else {
        console("No Account group found")
      }




      // setAccountGroupList(res.data.response_data)
      setIsRender(true)

    })
  };



  useEffect(() => {


    accountListDatas();



    //setAccountGroupList(data)

    // console.log("Account group list ",accountGroupList)


  }, [state.accountgroup,isSuccessRefreshList])



  /*
  useEffect(() => {
    window.addEventListener("load", handlePageLoading);
    return () => window.removeEventListener("load", handlePageLoading);
  }, [])
  */

  /*
    return !isPageLoading ? (
      <div >
  
  
        {
          accountGroupList.length <= 0 ? <><div><h4>No group found. Add new group</h4></div></> : (
            <>
               <Tree treeData={accountGroupList} showLine={true}
                onSelect={onSelect} defaultExpandAll={true} /> 
  
              <Table
                columns={groupColumn}
                // rowSelection={{ ...rowSelection, checkStrictly }}
                dataSource={accountGroupList}
                expandable={true}
                pagination={false}
  
              />
  
            </>
          )
        }
  
  
  
  
  
  
        <Drawer
          title="Account Group"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
  
        >
          <AccountGroupEntry data={accountGroupAddData} />
        </Drawer>
      </div>
    ) : (<><PageLoader /></>)
    */

    const onSearch = (e) => {
      setFilteredSearchList([]);
      setExpandedRowKeys([]);
      const string = e.target.value;
      const x = accountGroupList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);


      const newExpandedRowKeys = x.map((row) => row.key);
      setExpandedRowKeys(newExpandedRowKeys);

      setFilteredSearchList(x)
    }

  return (
    <div >




      <>
        {/* <Tree treeData={accountGroupList} showLine={true}
              onSelect={onSelect} defaultExpandAll={true} /> */}

        <CustomTableSearch onSearchTable={onSearch} style={{marginBottom: "8px"}} />  

        {
          filteredSearchList.length > 0 ? <>
          <Table
          columns={groupColumn}
          key={filteredSearchList.key}
          dataSource={filteredSearchList}
          //defaultExpandAllRows={true}
          expandable={{ 
            defaultExpandAllRows: true 
          }}
          expandedRowKeys={expandedRowKeys}
          onExpand={(expanded, record) =>
            setExpandedRowKeys(
              expanded
                ? [...expandedRowKeys, record.key]
                : expandedRowKeys.filter((key) => key !== record.key)
            )
          }
          pagination={false}

        />
          </> : "No Records Found"
        }

        
        
        

{/* <Input.Search
  placeholder="Search records"
  value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
/>
<Table
  expandable={{
    expandedRowRender: (record) => {
      const filteredData = record.children.filter((child) =>
        child.name.toLowerCase().includes(searchText.toLowerCase())
      );

      return (
        <Table
          dataSource={filteredData}
          columns={groupColumn}
          pagination={false}
        />
      );
    },
  }}
  dataSource={accountGroupList}
  columns={groupColumn}
/> */}








     



      </>

      <Drawer
        title="Account Group"
        width={DEFAULT_MASTER_DRAWER_WIDTH}
        onClose={onClose}
        visible={visible}
        bodyStyle={{
          paddingBottom: 80,
        }}
        destroyOnClose={true}
        closeIcon = {<><DrawableCloseIcon /></>}
      >
        <AccountGroupEntry data={accountGroupAddData} onDrawerClose={onClose} />
      </Drawer>
    </div>
  )

};

export default AccountGroupList;
